import { css, Drawer, drawerClasses, styled } from '@mui/material';

export const SDrawer = styled(Drawer)(
  ({ theme, open }) => css`
    width: ${open ? '208px' : 0};
    right: unset;
    transition: width ${theme.transitions.duration.leavingScreen}ms ${theme.transitions.easing.sharp};

    .${drawerClasses.paper} {
      padding: 0;
      box-sizing: border-box;
      border-right: 1px solid ${theme.palette.grey[200]};
      box-shadow: unset;
      overflow-x: hidden;

      ${theme.breakpoints.up('tablet')} {
        position: relative;
        z-index: ${theme.zIndex.basic};
      }
    }
  `,
);
